<template>
  <div class="wrapper_check_block">
    <div class="check_block row">
      <div class="checkMark col-6 col-md-3">
        <div>
          <img
            class="img-fluid"
            src="../../assets/images/png/check_1.png"
            alt=""
          />
        </div>
      </div>
      <div class="checkMark col-6 col-md-3">
        <div>
          <img
            class="img-fluid"
            src="../../assets/images/png/check_2.png"
            alt=""
          />
        </div>
      </div>
      <div class="checkMark col-6 col-md-3">
        <div>
          <img
            class="img-fluid"
            src="../../assets/images/png/check_3.png"
            alt=""
          />
        </div>
      </div>
      <div class="checkMark col-6 col-md-3">
        <div>
          <img
            class="img-fluid"
            src="../../assets/images/png/check_4.png"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "receipt-image-information"
};
</script>

<style lang="scss" scoped>
.wrapper_check_block {
  margin-top: 30px;
  @media (min-width: 991px) {
    display: flex;
    justify-content: center;

    .check_block {
      width: 60%;
    }
  }
}

.checkMark {
  justify-content: center;
  display: flex;
  @media (max-width: 992px) {
    margin-bottom: 40px;
  }
  .checkMark_img {
    width: 22px;
    height: 22px;
    position: absolute;
    bottom: 0;
    margin-left: -10px;
    margin-bottom: -5px;
    @media (max-width: 767px) {
      max-width: 30px;
      margin-left: -14px;
    }
  }
  .cross_red_img {
    width: 22px;
    height: 22px;
    position: absolute;
    bottom: 0;
    margin-left: -10px;
    margin-bottom: -5px;
    @media (max-width: 767px) {
      max-width: 24px;
      margin-left: -12px;
    }
  }
}
</style>